import React, { useState, useEffect } from 'react'
import { Switch, Route, Redirect, useParams, useRouteMatch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import axios from '~/data/http/axios'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import { inboxTabOptions, canManageInboxSettings } from '~/Classes/conversations'
import { handleGenericError } from '~/data/actions/siteActions'
import InboxTemplate from './template'

export default function InboxSettings({ userRole = null }) {
    const { path, url } = useRouteMatch()
    const { inboxId } = useParams()
    const dispatch = useDispatch()
    const accountUser = useSelector((state) => state.user)

    const [loading, setLoading] = useState(true)
    const [inbox, setInbox] = useState(null)

    useEffect(() => {
        if (!canManageInboxSettings(userRole, accountUser.userData.roleId)) {
            return window.open('/', '_self')
        }
        loadInitialData()
    }, [])

    async function loadInitialData() {
        try {
            await loadInbox()
        } finally {
            setLoading(false)
        }
    }

    async function loadInbox() {
        try {
            const { data } = await axios.get(`/inboxes/${inboxId}`)
            setInbox(data)
        } catch (error) {
            dispatch(handleGenericError(error))
            throw error
        }
    }

    if (loading) return <LoadingIcons className='mar-t24' />

    return (
        <Switch>
            <Route exact path={`${path}/:settingName`}>
                <InboxTemplate inbox={inbox} onUpdateName={loadInbox} loadInbox={loadInbox} userRole={userRole} />
            </Route>

            {/* Redirect if "naked" route */}
            <Route exact path={path}>
                <Redirect to={`${url}/${inboxTabOptions[0].value}`} />
            </Route>
        </Switch>
    )
}
